<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    modal-size="large"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${postUrl}/${inputs.id}` : postUrl"
      >
      <div class="row">
        <div class="col-md-6">
          <label for="refrence_id">
            Refrence ID
          </label>
          <app-input
              id="refrence_id"
              type="text"
              v-model="inputs.refrence_id"
              :required="true"
          />
        </div>

        <div class="col-md-6">
          <label for="company_name">
            Company Name
          </label>
          <app-input
              id="company_name"
              type="text"
              v-model="inputs.company_name"
              :required="true"
          />
        </div>
        <div class="col-md-6">
            <label for="text_input">
              {{ $t("contact") }}
            </label>
            <app-input
              id="contact"
              type="tel-input"
              :placeholder="$t('type_contact_number')"
              v-model="inputs.contact"
            />
          </div>
        <div class="col-md-6">
            <label for="text_input">
              {{ $t("email") }}
            </label>
            <app-input
              id="email"
              type="email"
              :required="true"
              v-model="inputs.email"
            />
        </div>

        <div class="col-md-6">
            <label for="text_input">
              {{ $t("phone") }}
            </label>
            <app-input
              id="phone"
              type="tel-input"
              :placeholder="$t('type_contact_number')"
              v-model="inputs.phone"
            />
          </div>
      </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";

export default {
  name: "RefrenceAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      fileView: false,
      postUrl:actions.COMPANY_TRADE_REFRENCE_STORE,
      preloader: false,
      roleLists: [],
      branchList: [],
      inputs: {
        company_id: this.companyId,
      },
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "refrence-add-edit-modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      let formData = new FormData;
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_TRADE_REFRENCE_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#refrence-add-edit-modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },

  mounted() {
    // $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    // });
  },
};
</script>
<style>
.custom-file-label{
  height: 36px !important;
}
</style>
